export default __webpack_public_path__ + "static/media/nuigsu-logo-gray-500.67bca526.svg";